import React from 'react';
import { Dialog } from '@mui/material';
import Box from '../single_component/Box';
import Text from '../single_component/Text';
import Button from '../single_component/Button';
import Image from '../single_component/Image';
import AlertIcon from '../../assets/images/Alert.png';

interface DeleteConfirmModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteConfirmModal = ({
  open,
  onCancel,
  onConfirm,
  loading = false,
}: DeleteConfirmModalProps) => {
  return (
    <Dialog maxWidth="sm" open={open} onClose={onCancel} scroll="paper">
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 3,
          textAlign: 'center',
          alignItems: 'center',
          gap: 2,
          width: 440,
        }}>
        <Image src={AlertIcon} style={{ width: 44 }} />
        <Box>
          <Text style={{ fontSize: 18, fontWeight: 600, color: '#104960' }}>
            Delete Record
          </Text>
          <Text style={{ fontSize: 14, color: '#667085', marginTop: 1 }}>
            Are you sure you want to delete this record?
          </Text>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '90%',
            gap: 2,
          }}>
          <Button
            extra={{ variant: 'outlined' }}
            onClick={onCancel}
            style={{ width: '48%', paddingBlock: 1 }}>
            Cancel
          </Button>
          <Button
            extra={{ variant: 'contained', btnDisableLoader: loading }}
            onClick={onConfirm}
            style={{
              width: '48%',
              paddingBlock: 1,
              backgroundColor: '#d32f2f',
            }}>
            Delete
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeleteConfirmModal;
